window.Lection = {};

require('./homework/homework');